<template>
	<v-tooltip top>
		<template v-slot:activator="{ on }">
			<v-btn v-on="on" icon :disabled="!target" @click="open()">
				<v-icon>{{ button.icon || 'mdi-open-in-new' }}</v-icon>
			</v-btn>
		</template>
		<span>{{ button.tooltip || 'Apri documento' }}</span>
	</v-tooltip>
</template>

<script>
	// Card del documento nella show della scadenza: il pulsante goTo generico passa
	// alla rotta solo l'id, mentre documents-show vuole anche il doctype.
	export default {
		name: 'open-document-button',
		props: {
			button: { type: Object, default: () => ({}) },
			model: { type: Object, default: () => ({}) },
			params: { type: Object, default: () => ({}) },
		},
		computed: {
			target() {
				if (!this.model.id || !this.params || !this.params.doctype) {
					return null
				}
				return { name: 'documents-show', params: { doctype: this.params.doctype, id: this.model.id } }
			},
		},
		methods: {
			open() {
				if (this.target) {
					this.$router.push(this.target).catch(() => {})
				}
			},
		},
	}
</script>
